module.exports = __webpack_public_path__ + "img/hyperx-cloud-mix-preview.bb80696f.png";